export const DASHBOARD_REQUESTS_RESOURCE = {
    total: 11,
    approve: {
        count: 5,
        items: [
            { id: 1042, name: 'Request #1042_2026-03-18 09:20', createdDate: '18-03-2026 09:20',
                status: 'WaitingForApproval', line: { id: 3, name: 'Line A' }, facility: null,
                partNumber: { id: 10, name: 'PN-123' }, highPriority: true, type: 'LINE' },
            { id: 1048, name: 'Request #1048_2026-03-19 08:40', createdDate: '19-03-2026 08:40',
                status: 'WaitingForApproval', line: null, facility: { id: 1, name: 'Facility Alpha' },
                partNumber: { id: 12, name: 'PN-442' }, highPriority: true, type: 'TICKET' },
            { id: 1051, name: 'Request #1051_2026-03-19 10:15', createdDate: '19-03-2026 10:15',
                status: 'WaitingForApproval', line: { id: 4, name: 'Line B' }, facility: null,
                partNumber: { id: 13, name: 'PN-550' }, highPriority: false, type: 'LINE' },
            { id: 1053, name: 'Request #1053_2026-03-19 10:45', createdDate: '19-03-2026 10:45',
                status: 'WaitingForApproval', line: null, facility: { id: 2, name: 'Facility Beta' },
                partNumber: { id: 11, name: 'PN-200' }, highPriority: false, type: 'MAINTENANCE' },
            { id: 1056, name: 'Request #1056_2026-03-19 11:20', createdDate: '19-03-2026 11:20',
                status: 'WaitingForApproval', line: { id: 6, name: 'Line D' }, facility: null,
                partNumber: { id: 17, name: 'PN-720' }, highPriority: false, type: 'LINE' }
        ]
    },
    process: {
        count: 3,
        items: [
            { id: 1036, name: 'Request #1036_2026-03-18 16:45', createdDate: '18-03-2026 16:45',
                status: 'Approved', line: { id: 7, name: 'Line E' }, facility: null,
                partNumber: { id: 14, name: 'PN-600' }, highPriority: false, type: 'LINE' },
            { id: 1039, name: 'Request #1039_2026-03-19 07:30', createdDate: '19-03-2026 07:30',
                status: 'Approved', line: null, facility: { id: 3, name: 'Facility Gamma' },
                partNumber: { id: 15, name: 'PN-610' }, highPriority: true, type: 'TICKET' },
            { id: 1041, name: 'Request #1041_2026-03-19 09:10', createdDate: '19-03-2026 09:10',
                status: 'WaitingForProcessing', line: { id: 8, name: 'Line F' }, facility: null,
                partNumber: { id: 16, name: 'PN-615' }, highPriority: false, type: 'LINE' }
        ]
    },
    transport: {
        count: 3,
        items: [
            { id: 1028, name: 'Request #1028_2026-03-17 13:15', createdDate: '17-03-2026 13:15',
                status: 'Processed', line: { id: 9, name: 'Line G' }, facility: null,
                partNumber: { id: 18, name: 'PN-730' }, highPriority: false, type: 'LINE', toolMaxTransportTime: 90 },
            { id: 1031, name: 'Request #1031_2026-03-18 15:25', createdDate: '18-03-2026 15:25',
                status: 'InTransport', line: null, facility: { id: 4, name: 'Facility Delta' },
                partNumber: { id: 19, name: 'PN-735' }, highPriority: true, type: 'MAINTENANCE' },
            { id: 1034, name: 'Request #1034_2026-03-19 08:05', createdDate: '19-03-2026 08:05',
                status: 'InTransport', line: { id: 10, name: 'Line H' }, facility: null,
                partNumber: { id: 20, name: 'PN-740' }, highPriority: false, type: 'LINE', toolMaxTransportTime: 60 }
        ]
    }
};

export const DASHBOARD_RETURNS_RESOURCE = {
    total: 9,
    approve: {
        count: 3,
        items: [
            { id: 889, name: 'Line A_PN-123_18-03-2026 11:05', createdDate: '18-03-2026 11:05',
                status: 'Delivered', line: { id: 3, name: 'Line A' }, facility: null,
                partNumber: { id: 10, name: 'PN-123' }, priority: 'High', type: 'LINE' },
            { id: 892, name: 'Facility Alpha_PN-442_19-03-2026 08:05', createdDate: '19-03-2026 08:05',
                status: 'WaitingForApproval', line: null, facility: { id: 1, name: 'Facility Alpha' },
                partNumber: { id: 12, name: 'PN-442' }, priority: 'Normal', type: 'TICKET' },
            { id: 894, name: 'Line B_PN-550_19-03-2026 09:35', createdDate: '19-03-2026 09:35',
                status: 'Delivered', line: { id: 4, name: 'Line B' }, facility: null,
                partNumber: { id: 13, name: 'PN-550' }, priority: 'High', type: 'LINE' }
        ]
    },
    process: {
        count: 3,
        items: [
            { id: 876, name: 'Line E_PN-600_18-03-2026 14:10', createdDate: '18-03-2026 14:10',
                status: 'Approved', line: { id: 7, name: 'Line E' }, facility: null,
                partNumber: { id: 14, name: 'PN-600' }, priority: 'Normal', type: 'LINE' },
            { id: 881, name: 'Facility Gamma_PN-610_19-03-2026 09:45', createdDate: '19-03-2026 09:45',
                status: 'WaitingForProcessing', line: null, facility: { id: 3, name: 'Facility Gamma' },
                partNumber: { id: 15, name: 'PN-610' }, priority: 'High', type: 'TICKET' },
            { id: 884, name: 'Line F_PN-615_19-03-2026 10:20', createdDate: '19-03-2026 10:20',
                status: 'WaitingForProcessing', line: { id: 8, name: 'Line F' }, facility: null,
                partNumber: { id: 16, name: 'PN-615' }, priority: 'Normal', type: 'LINE' }
        ]
    },
    transport: {
        count: 3,
        items: [
            { id: 861, name: 'Line G_PN-730_18-03-2026 10:55', createdDate: '18-03-2026 10:55',
                status: 'Approved', line: { id: 9, name: 'Line G' }, facility: null,
                partNumber: { id: 18, name: 'PN-730' }, priority: 'Normal', type: 'LINE' },
            { id: 865, name: 'Facility Delta_PN-735_19-03-2026 09:05', createdDate: '19-03-2026 09:05',
                status: 'InTransport', line: null, facility: { id: 4, name: 'Facility Delta' },
                partNumber: { id: 19, name: 'PN-735' }, priority: 'High', type: 'MAINTENANCE' },
            { id: 867, name: 'Line H_PN-740_19-03-2026 10:30', createdDate: '19-03-2026 10:30',
                status: 'InTransport', line: { id: 10, name: 'Line H' }, facility: null,
                partNumber: { id: 20, name: 'PN-740' }, priority: 'Normal', type: 'LINE' }
        ]
    }
};

export const DASHBOARD_TICKETS_SUMMARY_RESOURCE = {
    total: 12,
    operations: [
        {
            currentOperation: {
                id: 5,
                name: 'Approve'
            },
            new: 4,
            inProgress: 2,
            onHold: 1,
            total: 7
        },
        {
            currentOperation: {
                id: 8,
                name: 'Process'
            },
            new: 1,
            inProgress: 3,
            onHold: 1,
            total: 5
        }
    ]
};
